import urlApi from './urlApi';
import { getLongReadPosts } from './getLongReadPosts';
export var UPDATE_LR_POSITION_REQUEST = 'UPDATE_LR_POSITION_REQUEST';
export var UPDATE_LR_POSITION_SUCCESS = 'UPDATE_LR_POSITION_SUCCESS';
export var UPDATE_LR_POSITION_ERROR = 'UPDATE_LR_POSITION_ERROR';
export function updateLongReadPosition(id, newposition, lgid, uid, sign) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_LR_POSITION_REQUEST,
        });
        urlApi().updateLongReadPosition(id, newposition).then(function (res) {
            dispatch({
                type: UPDATE_LR_POSITION_SUCCESS,
                payload: res,
            });
            dispatch(getLongReadPosts(uid, lgid, sign));
        }).catch(function (e) {
            dispatch({
                type: UPDATE_LR_POSITION_ERROR,
            });
        });
    };
}
//# sourceMappingURL=updateLongReadPosition.js.mapimport urlApi from './urlApi';
import { getLongReadPosts } from './getLongReadPosts';
export var UPDATE_LR_POSITION_REQUEST = 'UPDATE_LR_POSITION_REQUEST';
export var UPDATE_LR_POSITION_SUCCESS = 'UPDATE_LR_POSITION_SUCCESS';
export var UPDATE_LR_POSITION_ERROR = 'UPDATE_LR_POSITION_ERROR';
export function updateLongReadPosition(id, newposition, lgid, uid, sign) {
    return function (dispatch) {
        dispatch({
            type: UPDATE_LR_POSITION_REQUEST,
        });
        urlApi().updateLongReadPosition(id, newposition).then(function (res) {
            dispatch({
                type: UPDATE_LR_POSITION_SUCCESS,
                payload: res,
            });
            dispatch(getLongReadPosts(uid, lgid, sign));
        }).catch(function (e) {
            dispatch({
                type: UPDATE_LR_POSITION_ERROR,
            });
        });
    };
}
//# sourceMappingURL=updateLongReadPosition.js.map